import { useSystemStore } from '@/stores/system';
import { storeToRefs } from 'pinia';

export type region<T> = {
  default: T;
  au?: T;
  us?: T;
  uk?: T;
  eu?: T;
  int?: T;
  ca?: T;
};

export const getRegionValue = <T>(object: region<T>) => {
  const { shopAttributes } = storeToRefs(useSystemStore());
  const { region } = shopAttributes.value;
  return object[region.toLowerCase()] || object.default;
};

export const resolveRegionOrArray = <T>(value: region<T[]> | T[] | undefined): T[] | undefined => {
  if (!value) return undefined;
  if (Array.isArray(value)) return value;
  return getRegionValue(value);
};

export const resolveChoiceGroupSelection = (
  value: string | region<string> | undefined,
): string | undefined => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return getRegionValue(value);
};

export const resolveRegionValue = <T>(value: region<T> | T | undefined): T | undefined => {
  if (!value) return undefined;
  if (typeof value === 'object' && 'default' in value) {
    return getRegionValue(value as region<T>);
  }
  return value;
};
